var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcToiletEntranceStep = function SvgIcToiletEntranceStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.594,
    y: 3.993,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.594,
    y: 3.993,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.594,
    y: 3.993,
    fill: "#67AEFF",
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 21,
    height: 12,
    x: 9.094,
    y: 16.793,
    fill: "currentColor",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.094 16.793h21v12h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.294 18.793a.2.2 0 0 0-.2.2v3.8a.2.2 0 0 1-.2.2h-3.6a.2.2 0 0 0-.2.2v3.8c0 .11.09.2.2.2h16.6a.2.2 0 0 0 .2-.2v-8a.2.2 0 0 0-.2-.2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.294 18.793a.2.2 0 0 0-.2.2v3.8a.2.2 0 0 1-.2.2h-3.6a.2.2 0 0 0-.2.2v3.8c0 .11.09.2.2.2h16.6a.2.2 0 0 0 .2-.2v-8a.2.2 0 0 0-.2-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.294 22.993v-1.5zm3.8-4h-1.5zm-.2 4v-1.5zm1.7-.2v-3.8h-3v3.8zm-5.3 1.7h3.6v-3h-3.6zm1.3 2.5v-3.8h-3v3.8zm15.3-1.3h-16.6v3h16.6zm-1.3-2.7v4h3v-4zm0-4v4h3v-4zm-11.3 1.3h12.6v-3h-12.6zm14.3-1.3a1.7 1.7 0 0 0-1.7-1.7v3a1.3 1.3 0 0 1-1.3-1.3zm-1.7 9.7a1.7 1.7 0 0 0 1.7-1.7h-3a1.3 1.3 0 0 1 1.3-1.3zm-18.3-1.7a1.7 1.7 0 0 0 1.7 1.7v-3a1.3 1.3 0 0 1 1.3 1.3zm1.7-5.5a1.7 1.7 0 0 0-1.7 1.7h3a1.3 1.3 0 0 1-1.3 1.3zm5.3-2.5a1.3 1.3 0 0 1-1.3 1.3v-3a1.7 1.7 0 0 0-1.7 1.7zm-3 3.8a1.3 1.3 0 0 1 1.3-1.3v3a1.7 1.7 0 0 0 1.7-1.7z",
    mask: "url(#b)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.594,
    y: 3.993,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 4.594,
    y: 3.993,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgIcToiletEntranceStep;